(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-coupon-badge"] && !Shopify.designMode) return;
  try {
    if (new URLSearchParams(window.location.search).get('fine_coupon') === '1' &&
      !document.querySelector('script[src*="shopify.privy.com/widget.js"]')) {
    const privyScript = document.createElement('script');
    privyScript.src = 'https://shopify.privy.com/widget.js?shop=finekagu.myshopify.com';
    privyScript.async = true;
    document.head.appendChild(privyScript);
  }

  document.querySelectorAll('.product-coupon-dock').forEach((dock) => {
    if (dock.dataset.couponDockReady === 'true') return;
    dock.dataset.couponDockReady = 'true';

    const toggle = dock.querySelector('.product-coupon-dock__toggle');
    const badge = dock.querySelector('.product-coupon-badge');
    const status = dock.nextElementSibling;
    const appliedStorageKey = 'fine_kagu_official_5_coupon_applied';
    let statusTimer;

    const showStatus = (message) => {
      window.clearTimeout(statusTimer);
      status.textContent = message;
      status.hidden = false;
      statusTimer = window.setTimeout(() => { status.hidden = true; }, 5200);
    };

    const hasAppliedCoupon = async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return dock.dataset.couponApplied === 'true';
        const cart = await response.json();
        const applications = [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.items || []).flatMap((item) =>
            (item.line_level_discount_allocations || []).map((allocation) => allocation.discount_application)
          )
        ];
        return applications.some((application) =>
          application?.type !== 'automatic' &&
          application?.title?.includes('公式限定5%OFF')
        ) || dock.dataset.couponApplied === 'true';
      } catch (error) {
        return dock.dataset.couponApplied === 'true';
      }
    };

    const hasCompletedPrivySignup = () =>
      document.cookie.split(';').some((cookie) =>
        cookie.trim().startsWith('_privy_email=') && cookie.trim() !== '_privy_email='
      );

    const rememberAppliedCoupon = () => {
      try { window.sessionStorage.setItem(appliedStorageKey, 'true'); } catch (error) {}
    };

    const wasAppliedInSession = () => {
      try { return window.sessionStorage.getItem(appliedStorageKey) === 'true'; } catch (error) { return false; }
    };

    toggle.addEventListener('click', () => {
      const collapsed = dock.classList.toggle('is-collapsed');
      toggle.setAttribute('aria-expanded', String(!collapsed));
      toggle.setAttribute('aria-label', collapsed ? toggle.dataset.expandLabel : toggle.dataset.collapseLabel);
      badge.tabIndex = collapsed ? -1 : 0;
    });

    badge.addEventListener('click', async (event) => {
      event.preventDefault();
      if (await hasAppliedCoupon() || hasCompletedPrivySignup() || wasAppliedInSession()) {
        rememberAppliedCoupon();
        showStatus(dock.dataset.statusApplied);
        return;
      }

      const destination = new URL(window.location.href);
      if (destination.searchParams.get('fine_coupon') !== '1') {
        destination.searchParams.set('fine_coupon', '1');
        window.location.assign(destination.toString());
        return;
      }

      const emailField = document.querySelector('.privy-widget-campaign-4693808 input[type="email"]');
      if (emailField && emailField.getClientRects().length) {
        emailField.focus();
        return;
      }

      showStatus(dock.dataset.statusUnavailable);
    });
  });
  } catch(e) { console.error(e); }
})();

})();
